/**
 * Swaps Keys and Values of the passed object
 *
 * @param object
 */
export function swapEnum<K extends string, V extends string>(object: Record<K, V>): Record<V, K> {
  const res = {} as Record<V, K>;

  (Object.keys(object) as K[]).forEach((key) => {
    res[object[key]] = key;
  });
  return res;
}
